export const STATIC_RANGES = [
  {
    label: 'Mês atual',
    range: () => ({
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'Mês passado',
    range: () => ({
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        1,
      ),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'Esse ano',
    range: () => ({
      startDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(new Date().getFullYear(), 11, 31),
    }),
    isSelected() {
      return true;
    },
  },
];
